import { loadStripe, type Stripe } from '@stripe/stripe-js'

let stripePromise: Promise<Stripe | null> | null = null

function getPublishableKey(): string {
  // Vite exposes env vars via import.meta.env and requires VITE_* prefix for client usage
  const live = (import.meta as any).env?.VITE_STRIPE_PUBLISHABLE_KEY_LIVE as string | undefined
  const test = (import.meta as any).env?.VITE_STRIPE_PUBLISHABLE_KEY as string | undefined
  const key = live ?? test ?? ''

  if (!key) {
    // Warn once at runtime if the key is missing; loadStripe will return null
    // eslint-disable-next-line no-console
    console.warn('[stripe] Missing VITE_STRIPE_PUBLISHABLE_KEY(_LIVE).')
  }

  return key
}

export function getStripe(): Promise<Stripe | null> {
  if (!stripePromise) {
    stripePromise = loadStripe(getPublishableKey())
  }
  return stripePromise
}


